export * from "../overrides/popover";

// soon to be depricated.
import { Popover } from "../overrides/popover";

export default Popover
